import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initGroupsPanel = createAction(`${actionKey}.INIT_GROUPS`, ()=>({}));
export const addToGroupFolder = createAction(`${actionKey}.ADD_TO_FOLDER`, (deviation, group, groupFolderId, actionbarType, biData)=>({
        deviation,
        group,
        groupFolderId,
        actionbarType,
        biData
    }));
export const addToGroupFolderSuccess = createAction(`${actionKey}.ADD_TO_FOLDER_SUCCESS`, (deviationId, groupFolderId, suggested)=>({
        deviationId,
        groupFolderId,
        suggested
    }));
export const addToGroupFolderFail = createAction(`${actionKey}.ADD_TO_FOLDER_FAIL`, (deviationId, groupFolderId)=>({
        deviationId,
        groupFolderId
    }));
